import { render, staticRenderFns } from "./MasterYear.vue?vue&type=template&id=ba87d962&scoped=true"
import script from "./MasterYear.vue?vue&type=script&lang=js"
export * from "./MasterYear.vue?vue&type=script&lang=js"
import style0 from "./MasterYear.vue?vue&type=style&index=0&id=ba87d962&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba87d962",
  null
  
)

export default component.exports